/**
 * Redux State Models
 * 
 * Defines the shape of Redux state for movies and TV shows
 */

// ============================================================================
// MOVIE STATE MODEL
// ============================================================================

export const movieInitialState = {
  // Movie list state
  movies: [],
  totalResults: 0,
  currentPage: 1,
  hasMore: true,
  
  // Loading states
  isLoading: false,
  isLoadingMore: false,
  
  // Error states
  error: null,
  
  // Filters
  filters: {
    selectedGenre: 'all',
    sortBy: 'trending',
    imdbRating: 0,
    rottenTomatoesRating: 0,
    fromYear: null,
    toYear: null,
  },
  
  // View mode
  viewMode: 'grid',
  
  // Prefetch state (replaces timer-based batch loading)
  prefetchQueue: [],
  prefetchedIds: [],
  isPrefetching: false,
  
  // Enhanced data cache
  enhancedDataCache: {},
  
  // Scroll restoration is now handled by TanStack Query
  
  // Performance tracking
  lastFetchTime: null,
  fetchCount: 0,
};

// ============================================================================
// TV STATE MODEL
// ============================================================================

export const tvInitialState = {
  // TV show list state
  tvShows: [],
  totalResults: 0,
  currentPage: 1,
  hasMore: true,
  
  // Loading states
  isLoading: false,
  isLoadingMore: false,
  
  // Error states
  error: null,
  
  // Filters
  filters: {
    selectedGenre: 'all',
    sortBy: 'trending',
    imdbRating: 0,
    rottenTomatoesRating: 0,
    fromYear: null,
    toYear: null,
  },
  
  // View mode
  viewMode: 'grid',
  
  // Prefetch state
  prefetchQueue: [],
  prefetchedIds: [],
  isPrefetching: false,
  
  // Enhanced data cache
  enhancedDataCache: {},
  
  // Scroll restoration is now handled by TanStack Query
  
  // Performance tracking
  lastFetchTime: null,
  fetchCount: 0,
};
